import React, { useEffect, useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import { IoIosTimer } from "react-icons/io";
import { IoPause, IoPlay, IoClose } from "react-icons/io5";

import {
  isiOS,
  isRunningStandalone,
} from "../../common/components/NavbarResponsive";
import { PALETTE } from "../../common/ThemeConstants";

export default function WorkoutBottomBar({ minutes, seconds, onClicked, onClose }) {
  // Store the initial time value when the component mounts
  const [initialTime, setInitialTime] = useState(0);

  // Set the initial time when the component mounts or when timeLeft changes from 0 to a positive value
  useEffect(() => {
    const timeLeft = minutes * 60 + seconds;
    if (timeLeft > 0 && initialTime === 0) {
      setInitialTime(timeLeft);
    }
  }, [minutes, seconds, initialTime]);

  // Calculate the percentage of time left for the progress bar
  const calculateProgressPercentage = () => {
    const timeLeft = minutes * 60 + seconds;
    if (timeLeft === 0 || initialTime === 0) return 0;
    return (timeLeft / initialTime) * 100;
  };
  const paddingBottom = isiOS() && isRunningStandalone() ? "1.5rem" : "0.5rem";
  const isTimerZero = minutes === 0 && seconds === 0;

  const openTimer = () => {
    onClicked();
  }

  return (
    <>
      <div
        onContextMenu={(e) => e.preventDefault()}
        className="align-self-center text-center plan-bottom-navbar"
        style={{ paddingBottom: paddingBottom }}
      >
        <Container
          className={`blur m-auto rounded-pill py-2 ${isTimerZero ? "shadow-sm-main" : "shadow-sm"}`}
          style={{
            background: "#ffffffb8",
            width: "96%",
            border: "1px solid #eeeded",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div
            className="timer-progress-bar"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "4px",
              width: `${calculateProgressPercentage()}%`,
              transition: "width 1s linear",
              background: PALETTE.MAINCOLORHOVER,
            }}
          />
          <Row className="px-2 py-2">
            <Col xs={2} className="text-start align-self-center pe-0" style={{ paddingLeft: 10 }}>
              <IoIosTimer
                size={32}
                color={isTimerZero ? PALETTE.MAINCOLOR : PALETTE.DARK}
                onClick={() => openTimer()}
                style={{ cursor: "pointer" }}
              />
            </Col>
            <Col xs={6} className="text-start px-0 align-self-center">
              <p
                className={`mb- 0 text-start mb-0`}
                style={{
                  fontSize: 24,
                  width: "fit-content",
                  fontWeight: "bold",
                  color: isTimerZero ? PALETTE.MAINCOLOR : PALETTE.DARK,
                  animation: isTimerZero ? "pulse 1s infinite" : "",
                  cursor: "pointer",
                }}
                onClick={() => openTimer()}
              >
                {`${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`}
              </p>
            </Col>
            <Col xs={4} className="text-end align-self-center ps-0" style={{ paddingRight: 10 }}>
              <IoClose
                size={24}
                color={PALETTE.GRAY}
                onClick={onClose}
                style={{ cursor: "pointer" }}
              />
            </Col>
          </Row >
        </Container >
      </div >
    </>
  );
}
